import React from "react";
import Alert from "shared/components/Alert";

type NoTableItemsMessageProps = {
  message: React.ReactNode | string;
};

const NoTableItemsMessage: React.FC<NoTableItemsMessageProps> = ({
  message,
}) => {
  if (typeof message === "string") {
    return <Alert severity="info">{message}</Alert>;
  }
  return <>{message}</>;
};
export default NoTableItemsMessage;
